import { Injectable } from '@angular/core';

import { saveAs } from 'file-saver';

import { BrowserProviderService } from './browser-provider.service';
import * as XLSX from "xlsx";

@Injectable({
    providedIn: 'root'
})
export class DownloadService {
    static readonly bolWindowName: string = 'bol';

    constructor(private browser: BrowserProviderService) { }

    Download(blob: Blob, filename?: string): void {
        saveAs(blob, filename);
    }

    OpenInNewWindow(blob: Blob, windowName: string): void {
        const url = this.browser.createObjectURL(blob);
        this.browser.open(url, windowName);
        setTimeout(() => this.browser.revokeObjectURL(url), 300000);
    }

    downloadAsExcel(wb: XLSX.WorkBook, filename: string): void {
        const bytes = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        const blob = new Blob([bytes], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        this.Download(blob, filename);
    }
}
